export default __webpack_public_path__ + "static/media/health_check_male_Cn.b5c79bcc.webp";